import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-left-icons',
  templateUrl: './left-icons.component.html',
  styleUrls: ['./left-icons.component.scss'],
})
export class LeftIconsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
